import { useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export const SEO = ({ page }) => {
  const { t, language } = useLanguage();
  
  const siteUrl = 'https://netgrid.host';
  
  // Map page names to URL slugs
  const slugMap = {
    home: '',
    netherlands: '/vps-netherlands',
    germany: '/vps-germany',
    poland: '/vps-poland',
    latvia: '/vps-latvia',
    romania: '/vps-romania',
    italy: '/vps-italy',
    switzerland: '/vps-switzerland',
    usa: '/vps-usa',
    miami: '/vps-miami',
    czechia: '/vps-czechia',
    bulgaria: '/vps-bulgaria',
    greece: '/vps-greece',
    spain: '/vps-spain',
    vpn: '/vpn',
    affiliateTerms: '/affiliate-terms',
    wiki: '/wiki',
    'wiki-shared-1gbps-port-explained': '/wiki/shared-1gbps-port-explained',
    'wiki-internet-speed-explained': '/wiki/internet-speed-explained',
    'wiki-ip-geolocation-explained': '/wiki/ip-geolocation-explained',
    'wiki-firewall-and-ports-explained': '/wiki/firewall-and-ports-explained',
    'wiki-essential-linux-diagnostics': '/wiki/essential-linux-diagnostics',
    'wiki-launch-website-quick-start': '/wiki/launch-website-quick-start',
    'wiki-wireguard-vpn-setup': '/wiki/wireguard-vpn-setup',
    'wiki-crypto-payment-exact-amount': '/wiki/crypto-payment-exact-amount',
  };
  const pageSlug = slugMap[page] !== undefined ? slugMap[page] : `/${page}`;
  
  const title = t(`seo.${page}.title`);
  const description = t(`seo.${page}.description`);
  const keywords = t(`seo.${page}.keywords`);
  
  const currentUrl = `${siteUrl}${language === 'ru' ? '/ru' : ''}${pageSlug}`;
  
  useEffect(() => {
    // Update document title
    document.title = title;
    
    // Update document lang
    document.documentElement.lang = language === 'en' ? 'en' : 'ru';
    
    // Helper function to update or create meta tag
    const updateMetaTag = (selector, attribute, value) => {
      let element = document.querySelector(selector);
      if (!element) {
        element = document.createElement(selector.includes('link') ? 'link' : 'meta');
        const attrRegex = /\[([\w-]+)="([^"]*)"\]/g;
        let match;
        while ((match = attrRegex.exec(selector)) !== null) {
          element.setAttribute(match[1], match[2]);
        }
        document.head.appendChild(element);
      }
      if (element.tagName === 'LINK') {
        element.setAttribute('href', value);
      } else {
        element.setAttribute('content', value);
      }
    };
    
    // Update basic meta tags
    updateMetaTag('meta[name="description"]', 'name', description);
    updateMetaTag('meta[name="keywords"]', 'name', keywords);
    
    // Update Open Graph tags
    updateMetaTag('meta[property="og:type"]', 'property', 'website');
    updateMetaTag('meta[property="og:url"]', 'property', currentUrl);
    updateMetaTag('meta[property="og:title"]', 'property', title);
    updateMetaTag('meta[property="og:description"]', 'property', description);
    updateMetaTag('meta[property="og:image"]', 'property', `${siteUrl}/og-image.png`);
    updateMetaTag('meta[property="og:locale"]', 'property', language === 'en' ? 'en_US' : 'ru_RU');
    
    // Update Twitter tags
    updateMetaTag('meta[name="twitter:card"]', 'name', 'summary_large_image');
    updateMetaTag('meta[name="twitter:url"]', 'name', currentUrl);
    updateMetaTag('meta[name="twitter:title"]', 'name', title);
    updateMetaTag('meta[name="twitter:description"]', 'name', description);
    updateMetaTag('meta[name="twitter:image"]', 'name', `${siteUrl}/og-image.png`);
    
    // Update canonical
    updateMetaTag('link[rel="canonical"]', 'rel', currentUrl);
    
    // Update hreflang
    updateMetaTag('link[rel="alternate"][hreflang="en"]', 'rel', `${siteUrl}${pageSlug}`);
    updateMetaTag('link[rel="alternate"][hreflang="ru"]', 'rel', `${siteUrl}/ru${pageSlug}`);
    updateMetaTag('link[rel="alternate"][hreflang="x-default"]', 'rel', `${siteUrl}${pageSlug}`);
    
  }, [title, description, keywords, currentUrl, language, siteUrl, page]);
  
  return null;
};
